export default {
  'en-US': {
    messeges: {
      previous: 'Previous',
      next: 'Next',
      part1: 'Page ',
      part2: ' of ',
      part3: ' | Go to page',
      recordsPart1: ' | Showing',
      recordsPart2: ' records'
    }
  },
  'ja-JP': {
    messeges: {
      previous: '前',
      next: '次',
      part1: 'ページ ',
      part2: ' の ',
      part3: ' | ページに移動',
      recordsPart1: ' | 見せる',
      recordsPart2: ' 記録'
    }
  }
}
